import { tt } from '@agos/shared'

/**
 * The external courier's sign-up - `FRONTEND.md` §9.786, on BACKEND.md §10A.438 F, owner O139 (answer 7: *the
 * driver signs up and the restaurant approves*).
 *
 * The page is `/kurier` on the manager's own address, so the account is created in this franchise. **The server
 * decides every rule** (`StaffAuthService.registerCourier`: a real address, a password of six, a phone) and names the
 * one it refuses; this only refuses an empty box, which would otherwise reach the server as a refusal about a field
 * the courier has not noticed is blank.
 */

export const COURIER_SIGNUP_PATH = '/api/v1/auth/courier-signup'

export interface CourierSignupForm {
  firstName: string
  lastName: string
  phone: string
  email: string
  password: string
}

export const EMPTY_SIGNUP: CourierSignupForm = { firstName: '', lastName: '', phone: '', email: '', password: '' }

export const SIGNUP_LABELS: Record<keyof CourierSignupForm, string> = {
  firstName: tt('Meno'),
  lastName: tt('Priezvisko'),
  phone: tt('Telefón'),
  email: tt('E-mail'),
  password: tt('Heslo'),
}

const ORDER: readonly (keyof CourierSignupForm)[] = ['firstName', 'lastName', 'phone', 'email', 'password']

/** The first empty box, named - or null. */
export function signupProblem(form: CourierSignupForm): string | null {
  for (const field of ORDER) {
    if (form[field].trim() === '') return `${tt('Vyplňte')}: ${SIGNUP_LABELS[field]}`
  }
  return null
}

/** What the server takes: trimmed, the password as typed. */
export function signupBody(form: CourierSignupForm): Record<string, string> {
  return {
    firstName: form.firstName.trim(),
    lastName: form.lastName.trim(),
    phone: form.phone.trim(),
    email: form.email.trim(),
    password: form.password,
  }
}
